// @flow

export const COMPANY_REGISTRATION_INIT = 'COMPANY_REGISTRATION_INIT'
export const COMPANY_REGISTRATION_INVITE = 'COMPANY_REGISTRATION_INVITE'
export const COMPANY_REGISTRATION_SET_FIELD = 'COMPANY_REGISTRATION_SET_FIELD'
export const COMPANY_REGISTRATION_ERROR = 'COMPANY_REGISTRATION_ERROR'
export const COMPANY_REGISTRATION_CONFIRMED = 'COMPANY_REGISTRATION_CONFIRMED'
